import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Markdown from 'components/commercetools-ui/organisms/markdown';

const ImageBanner = (props: any) => {
    const { content: sectionWithImageText } = props;
    const imageDescription = sectionWithImageText?.description;
    const descriptionArray: any[] = [];
    descriptionArray?.push(imageDescription);

    const handleDownloadPDF = () => {
        const pdfUrl = sectionWithImageText?.ctas[0]?.button?.href;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'your-filename.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className={`relative left-full w-screen -translate-x-full lg:grid lg:grid-cols-12 ${sectionWithImageText.additional_css}`}>
            <div
                id="advice-section"
                className={`flex items-center  lg:col-span-12 lg:px-0 ${sectionWithImageText?.desktop_image_alignment === 'Left' ? 'md:flex-row' : 'lg:flex-row-reverse'
                    } ${sectionWithImageText?.mobile_image_alignment === 'Top' ? 'flex-col' : 'flex-col'}`}
            >
                <div className="middleresolution:h-[37rem]  relative h-[20rem] w-full md:h-[46rem] lg:flex-1  lg:flex-grow xl:h-[32rem] 2xl:h-[45rem] ">
                    {sectionWithImageText?.image?.url && (
                        <Image
                            priority
                            loading="eager"
                            src={sectionWithImageText?.image?.url}
                            alt={sectionWithImageText?.image?.description}
                            fill
                            style={{ objectFit: 'cover' }}
                        />
                    )}
                </div>
                <div className="flex-1 flex-grow pb-48 lg:px-48 2xl:px-144">
                    {descriptionArray?.map((field: any) => (
                        <div key={field?.categoryId}>
                            <Markdown
                                markdown={field}
                                className="image-container px-24 text-center text-16 font-normal leading-6 text-[#333] md:text-18  lg:leading-8 xl:text-16 2xl:text-20 [&>div>img]:mb-10"
                            />
                        </div>
                    ))}
                    {sectionWithImageText?.ctas?.[0]?.button && (
                        <div className="px-24 ">
                            <Link link={sectionWithImageText?.ctas?.[0]?.button?.href?.href}>
                                <Button
                                    onClick={handleDownloadPDF}
                                    className="m-auto mt-48 block w-full rounded-none border-2 border-[#2B2C39] bg-white px-18 py-16 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4] md:px-32 md:py-16 lg:w-fit"
                                >
                                    <Typography
                                        as="span"
                                        className="text-16 font-semibold leading-5  text-[#090909] lg:leading-6 xl:text-14 2xl:text-16"
                                    >
                                        {sectionWithImageText?.ctas?.[0]?.button?.title}
                                    </Typography>
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImageBanner;